import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import * as Yup from 'yup';
import useQuery from 'hooks/useQuery';
import { Form, Wrapper, AuthFooter } from 'components';
import { REGISTER, FORGOT_PASSWORD, ROOT } from 'constants/routes';
import FullPageCardContainer from 'components/FullPageCardContainer/FullPageCardContainer';
import { useLogin } from 'api/auth/hooks';

const LoginPage = () => {
  const { t } = useTranslation(['pages']);
  const query = useQuery();
  const redirectAddress = query.get('redirectUrl') || ROOT;
  const { mutateAsync: loginUser, isPending } = useLogin();
  return (
    <FullPageCardContainer
      xs="12"
      md="8"
      lg="6"
      footer={AuthFooter}
      variant="auth"
      cornerAction={{ label: 'Sign up', to: REGISTER }}
    >
      <h1 className="auth-page-title">{t('login.title')}</h1>
      <p className="auth-page-subtitle">{t('login.subtitle')}</p>
      <Form
        initialValues={{
          email: '',
          password: '',
          countryCode: '',
          phoneNumber: '',
        }}
        onSubmit={async ({ email, password }) => {
          await loginUser({ email, password, redirectAddress });
        }}
        validationSchema={Yup.object({
          email: Yup.string().email('Invalid email address').required(t('validation:required')),
          password: Yup.string()
            .min(6, t('validation:atLeastChars', { number: 6 }))
            .required(t('validation:required')),
        })}
        renderDefaultButtons={false}
      >
        <Form.Group>
          <Form.Label>{t('login.email')}</Form.Label>
          <Form.Input name="email" type="email" placeholder="johndoe@rambla.com" />
        </Form.Group>
        <Form.Group>
          <Row>
            <Col>
              <Form.Label>{t('login.password')}</Form.Label>
            </Col>
          </Row>
          <Form.Password name="password" placeholder={t('login.passwordPlaceholder')} />
        </Form.Group>
        <Wrapper mb-3>
          <Form.Submit
            size="lg"
            variant="primary"
            block
            style={{ width: '100%' }}
            ignoreClickedState
            isLoading={isPending}
          >
            {t('login.login')}
          </Form.Submit>
        </Wrapper>
        <Wrapper d-flex flex-column justify-content-center align-items-center>
          <Link to={FORGOT_PASSWORD} className="auth-secondary-link">
            {t('login.forgetPassword')}
          </Link>
        </Wrapper>
      </Form>
    </FullPageCardContainer>
  );
};

export default LoginPage;
